<template>
	<div>
		<template v-if="ready">
			<h2>
				{{ $t('form-schedule') }}
				<div class="float-right">
					<button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
				</div>
			</h2>

			<div v-if="saved">
				<div class="alert alert-success mt-8">{{ $t('form-type-saved') }}</div>
			</div>

			<div class="form-group">
				<label for="formschedule-title">{{ $t('title') }}</label>
				<input id="formschedule-title" name="title" class="form-control" :class="{error:errors.title}" v-model="formschedule.title" :placeholder="$t('title')" required v-validate>
				<span class="text-error">{{ errors.title }}</span>
			</div>

			<div class="form-group">
				<label for="form">{{$t('form')}}</label>
				<select class="form-control" :class="{error:errors.form}" id="form" name="form" v-model="formschedule.form_id" required v-validate>
					<option value="">{{ $t('select-caps') }}</option>
					<option v-for="(form, i) in forms" :key="i" :value="form.id">{{ form.title }}</option>
				</select>
				<span class="text-error">{{ errors.form }}</span>
			</div>

			<div class="form-group">
				<label>{{ $t('approval-from') }}</label>
				<input
					type="text"
					:value="signoffdisplayname"
					class="form-control"
					@focus="selectTeacher"
					:placeholder="$t('none')"
				/>
			</div>

			<div class="form-group">
				<label for="form">{{$t('workbooks')}}</label>
				<div class="clearfix">
					<div class="pseudo-input mb-4">
						<input
							type="search"
							class="input-bare w-full flex-1"
							:placeholder="$t('workbooks')"
							v-if="!formschedule.workbooks.length"
							@click="openWorkbooksModal"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(workbook, index) in formschedule.workbooks"
							v-bind:key="index"
						>
							{{ workbook.title }}
							<a @click="removeWorkbook(workbook)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="formschedule.workbooks.length"
							@click="openWorkbooksModal"
						>
							<b-icon icon="plus"></b-icon> {{ $t('add') }}
						</span>
					</div>
				</div>
			</div>


			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="formschedule.programme_id">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme.Id"
							>{{ programme.Name}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="formschedule.year">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="year in selectedProgrammeYears"
							:key="year"
							:value="year"
							>{{ year }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="formschedule.group_id">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('every') }}</label>
						<select class="form-control" v-model="formschedule.month"  :class="{error:errors.month}" required v-validate>
							<option value=""></option>
							<option v-for="item in 12" :value="item" :key="item">{{ $t('month-long-' + item) }}</option>
							<option value="other">{{ $t('other') }}</option>
						</select>
						<span class="text-error">{{ errors.month }}</span>
					</div>
				</div>
				<div class="col-md-4" v-if="formschedule.month!='other'">
					<div class="form-group">
						<label>{{ $t('day') }}</label>
						<select class="form-control" v-model="formschedule.dayofmonth" :required="formschedule.month!='other'" :v-validate="formschedule.month!='other'">
							<option v-for="item in 28" :value="item" :key="item">{{ item }}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row" v-if="formschedule.month=='other'">
				<div class="col-md-2">
					<div class="form-group">
						<label>{{ $t('period') }}</label>
						<input name="period" type="number" class="form-control" v-model="formschedule.length" :class="{error:errors.period}" :required="formschedule.month=='other'" :v-validate="formschedule.month=='other'">
						<span class="text-error">{{ errors.period }}</span>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('interval') }}</label>
						<select name="denominator" class="form-control" v-model="formschedule.denominator" :class="{error:errors.denominator}" :required="formschedule.month=='other'" :v-validate="formschedule.month=='other'">
							<option value="MONTH">{{ $t('months') }}</option>
							<option value="WEEK">{{ $t('weeks') }}</option>
							<option value="DAY">{{ $t('days') }}</option>
						</select>
						<span class="text-error">{{ errors.denominator }}</span>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group" v-if="formschedule.denominator=='WEEK'">
						<label>{{ $t('day') }}</label>
						<select class="form-control" v-model="formschedule.dayofweek">
							<option v-for="item in 7" :value="item" :key="item">{{ $t('dayname-long-' + item) }}</option>
						</select>
					</div>
					<div class="form-group" v-if="formschedule.denominator=='MONTH'">
						<label>{{ $t('day') }}</label>
						<select class="form-control" v-model="formschedule.dayofmonth">
							<option v-for="item in 28" :value="item" :key="item">{{ item }}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label>
							<input type="checkbox" v-model="hasdeadline" :value="true" />
							{{ $t('set-deadline') }}
						</label>
					</div>
				</div>
			</div>

			<div class="row" v-if="hasdeadline">
				<div class="col-md-2">
					<div class="form-group">
						<label>{{ $t('deadline') }}</label>
						<input name="period" type="number" class="form-control" v-model="formschedule.deadlinelength">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('interval') }}</label>
						<select name="denominator" class="form-control" v-model="formschedule.deadlinedenominator">
							<option value="MONTH">{{ $t('months') }}</option>
							<option value="WEEK">{{ $t('weeks') }}</option>
							<option value="DAY">{{ $t('days') }}</option>
						</select>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div>
				<div class="skeleton midnight h20 mr-4 mb-3 float-left" v-for="n in 10" :key="n"></div>
			</div>
		</template>

    </div>
</template>

<script>
import { ValidateMixin } from '@/mixins';
export default {
	mixins: [ValidateMixin],
	components: {
	},
    data: function() {
        return {
        	ready: false,
        	errors: [],
        	forms: [],
        	hasdeadline: false,
        	formschedule: {
        		id: null,
        		form_id: null,
        		usersignofffrom_id: null,
        		title: '',
        		programme_id: null ,
        		year: null ,
        		group_id: null,
        		month: null,
        		dayofweek: null,
        		dayofmonth: 1,
        		length: null,
        		denominator: null,
        		deadlinelength: null,
        		deadlinedenominator: null,
        		workbooks: []
        	},
        	signoffdisplayname: null,
        	saved: false
        }
    },
    methods: {
    	save() {

        	this.validate();

        	// todo: would like to integrate this into v-validate somehow
        	if (this.hasErrors) {
        		return false;
        	}

			var data = JSON.parse(JSON.stringify(this.formschedule));
			if(data.month == 'other'){
				data.month = null;
			}
			if(!this.hasdeadline){
				data.deadlinelength = null;
				data.deadlinedenominator = null;
			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/formschedule/save`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					if(json.item.month == null){
						json.item.month = 'other';
					}
					if(json.item.deadlinelength){
						this.hasdeadline = true;
					}
					this.formschedule = json.item;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
    	},
    	getFormschedule(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/formschedule/getitem/${id}`)
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {
					if(json.item.month == null){
						json.item.month = 'other';
					}
					if(json.item.deadlinelength){
						this.hasdeadline = true;
					}
					this.formschedule = json.item;
					this.selectedTeacherName();
    				this.ready = true;
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
    	},
		getForms() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectform`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.forms;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		selectTeacher(){
			const self = this;
			this.$users.getTeachers.call(this).then(teachers => {
				const processedTeachers = teachers.map(teacher => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function(selection) {
					self.signoffdisplayname = selection.displayName;
					self.formschedule.usersignofffrom_id = selection.id;
					self.$store.commit("closeModal");
				},
				selected: [
					{
					id: self.formschedule.usersignofffrom_id
					}
				],
				data: processedTeachers,
				captionKey: "displayName",
				subcaptionKey: "subcaption"
				});
			});
		},

    	selectedTeacherName(){
			this.$users.getDisplayName(this.formschedule.usersignofffrom_id).then(displayname => {
				return this.signoffdisplayname = displayname;
			});
    	},
		openWorkbooksModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select-workbooks'),
				selectCallback: function(selection) {
					const isSelected = self.formschedule.workbooks.find(
						(workbook, i) => {
							if(workbook.id === selection.id){
								self.$delete(self.workbooks, i);
								return true;
							}
						}
					);
					if (!isSelected) {
						self.formschedule.workbooks.push(selection);
					}
				},
				selected: self.formschedule.workbooks,
				data: self.$config.getValue('workbooks'),
				captionKey: 'title'
			});
		},
		removeWorkbook(selection) {
			const self = this
			self.formschedule.workbooks.find(
				(workbook, i) => {
					if(workbook.id === selection.id){
						self.$delete(self.formschedule.workbooks, i);
						return true;
					}
				}
			);
			return false;
		}
    },
    computed: {
    	selectedProgrammeYears(){
    		if(this.formschedule.programme_id){
    			return Number(this.$config.getValue('programmes')[this.formschedule.programme_id].CourseLengthYears);
    		} else {
    			return 5;
    		}
    	}
    },
    mounted() {
		this.getForms();
    	if(this.$route.params.formscheduleid) {
    		this.getFormschedule(this.$route.params.formscheduleid)
    	} else {
    		this.$store.commit("hideBlockingSpinner");
    		this.ready = true;
    	}
    }
}
</script>
